import { createState } from '../../lib/create-state';

export type ErrorState = {
    type: string;
};

export const [error, resetError] = createState<ErrorState>({
    type: '',
});
